/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCellSignal1 = createReactComponent("cell-signal-1", "IconCellSignal1", [
  [
    "path",
    {
      d: "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z",
      key: "svg-0"
    }
  ]
]);

export { IconCellSignal1 as default };
//# sourceMappingURL=IconCellSignal1.js.map
